<template>
  <div>
    <div class="delete-dialog-header">
      <span>Confirmation</span>
    </div>
    <div class="delete-dialog-body">
      <span>Are you SURE you want to delete this Notification?</span>
    </div>
    <div class="delete-dialog-footer">
      <button type="button" class="btn btn-secondary" @click="$modal.hide('confirmDelete')">Cancel</button>
      <button type="button" class="btn btn-primary" @click="deleteNotification(index)" title="Delete">Ok</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'confirmDelete',
  props: {
    index: Number
  },

  methods: {
    deleteNotification (index) {
      this.$emit('deleteNotification', index)
      this.$modal.hide('confirmDelete')
    }
  }
}
</script>

<style scoped>
  .delete-dialog-header {
    height: 35px;
    background-color: #428bca;
    background-image: linear-gradient(to bottom, #428bca 0%,#2d6ca2 100%);
    padding: 8px;
    top: 0;
    color: white;
    font-weight: 700;
  }

  .delete-dialog-body {
    padding: 15px;
    font-weight: 500;
    font-size: 14px;
  }

  .delete-dialog-footer {
    height: 50px;
    width:100%;
    position:absolute;
    bottom: 0;
    padding: 7px;
    border-top: 1px solid #428bca;
  }

  .delete-dialog-footer button {
    margin-left: 5px;
    float: right;
  }

</style>
